module.exports = "/images/Miniature golf.svg?73b0b7023f992b18982a0a4519e8ef7f";